'use client';

import { useState } from 'react';
import Image from 'next/image';

import { Button, Input, Modal } from '@shared/ui/components';
import ArrowIcon from '@public/icons/arrow-right.svg';
import CheckIcon from '@public/icons/check-extra-thin.svg';

import { alumniContactApi } from '../../api/contact.api';

import styles from './AlumniContactUsModal.module.scss';

interface AlumniContactUsModalProps {
  isOpen: boolean;
  close: () => void;
}

const AlumniContactUsModal = (props: AlumniContactUsModalProps) => {
  const { isOpen, close } = props;

  const [discord, setDiscord] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [isMessageSent, setMessageSent] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);

  const isFormValid: boolean = (() => {
    return !!discord && !!code;
  })();

  const sendMessage = () => {
    if (isLoading || !isFormValid) {
      return;
    }

    setLoading(true);

    alumniContactApi({
      username: discord,
      code,
    })
      .then(() => {
        setMessageSent(true);
        setCode('');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      header={isMessageSent ? ' ' : 'Alumni Discord'}
      className={styles.modal}
      bodyClassName={styles.modal_body}
      headerClassName={styles.modal_header}
      separateClose
      close={close}
      onClose={() => {
        setMessageSent(false);
      }}
    >
      {isMessageSent ? (
        <div className={styles.sent}>
          <div className={styles.sent_icon}>
            <Image src={CheckIcon} alt="Check" draggable={false} />
          </div>

          <div className={styles.sent_text}>Your information has been sent successfully</div>

          <Button size="l" variant="filled" className={styles.sent_button} onClick={close}>
            OK
          </Button>
        </div>
      ) : (
        <>
          <div className={styles.form}>
            <Input placeholder="Discord username" value={discord} onChange={setDiscord} />

            <Input placeholder="Certificate code (Alumni code)" value={code} onChange={setCode} />
          </div>

          <Button
            size="l"
            variant="filled"
            className={styles.button}
            loading={isLoading}
            disabled={!isFormValid}
            onClick={sendMessage}
          >
            <div>Send</div>
            <Image src={ArrowIcon} alt="Arrow" draggable={false} />
          </Button>
        </>
      )}
    </Modal>
  );
};

export default AlumniContactUsModal;
